"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteSummaryContextProvider = exports.useQuoteSummaryContext = void 0;
var pages_common_1 = require("@qwilr/pages-common");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var QuoteSummaryContext = react_1.default.createContext(undefined);
var useQuoteSummaryContext = function () {
    var ctx = react_1.default.useContext(QuoteSummaryContext);
    if (!ctx) {
        throw new Error("useQuoteSummaryContext() must be used within an QuoteSummaryContext Provider");
    }
    return ctx;
};
exports.useQuoteSummaryContext = useQuoteSummaryContext;
exports.QuoteSummaryContextProvider = (0, mobx_react_1.observer)(function (_a) {
    var children = _a.children, currencyCode = _a.currencyCode, currencyLocale = _a.currencyLocale, showDecimals = _a.showDecimals, getLabel = _a.getLabel, settings = _a.settings;
    return (react_1.default.createElement(QuoteSummaryContext.Provider, { value: {
            settings: settings,
            formatCurrency: function (amount) {
                return (0, pages_common_1.formatWithDecimals)(amount, currencyCode, { showDecimalPlaces: showDecimals, locale: currencyLocale });
            },
            getLabel: getLabel,
        } }, children));
});
